import React from 'react';
import AppProviders from '@/components/AppProviders';

const WrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <AppProviders>{element}</AppProviders>;
};

export default WrapRootElement;
